import {GenericType} from "~/interfaces/genericTypeInterfaces"
import WorkflowStepAction from "../../../formability/form_builder/models/workflow/workflowStepAction"
import ReferencePathService from "~/services/referencePathServices/referencePathService"
import {ModelType} from "~/enums/modelType"
import {IReferencePathNodeSpecific, IReferencePathNodeWorkflowStepAction} from "~/interfaces/referencePathInterfaces"

export default class WorkflowStepActionPathService extends ReferencePathService {
  imposterModelType: ModelType = ModelType.WorkflowStepAction

  constructor(private workflowStepActionNode: IReferencePathNodeWorkflowStepAction) {
    super();
  }

  get label(): string {
    return this.reference()?.title;
  }

  get nodes(): [IReferencePathNodeWorkflowStepAction] {
    return [this.workflowStepActionNode];
  }

  reference(): WorkflowStepAction {
    return WorkflowStepAction.repo.findById(this.workflowStepActionNode.reference_id);
  }

  get referenceGenericModelType(): GenericType {
    return ModelType.Object;
  }

  get referenceModelType(): ModelType {
    return this.reference()?.modelType
  }

  canLinkTo(node: IReferencePathNodeSpecific): boolean {
    let decision: boolean
    if (!this.referenceExists) {
      decision = false // own reference (workflow step action) has to exist
    } else {
      decision = !node // workflow step action node must be the last node in the list
    }
    this.debugCanLinkTo('WorkflowStepActionPathService', this.workflowStepActionNode, node, decision)
    return decision
  }

  referenceIsCollection = false
}